import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const SubscriptionPopup = ({ onExtend, onLogout }) => {
  const dialogRef = useRef(null);
  const location = useLocation();
  const isLoginPage = location.pathname === "/";
  const [isDialogOpen, setIsDialogOpen] = useState(true);

  useEffect(() => {
    const showDialog = () => {
      if (dialogRef.current) {
        if (dialogRef.current.open) {
          dialogRef.current.close();
        }
        dialogRef.current.showModal();
      }
    };


    showDialog();


    if (location.pathname !== "/") {
      showDialog();
    }
  }, [location]);

  const closeDialog = () => {
    dialogRef.current?.close();
    setIsDialogOpen(false);
  };

  return (
    <>
    {isDialogOpen && (
    <div className="overlay">
      <dialog
        ref={dialogRef}
        className="subscription-end-popup border-0"
      >
        <h2 className="title">
          Subscription Ended
        </h2>
        <p className="message">
          Your subscription has ended. To continue using our services, please extend your subscription.
        </p>

        <div className="action-btns d-flex justify-content-around gap-3">
          <button
            onClick={() => {
              onExtend();
              closeDialog();
            }}
            className="ex-sub-btn d-flex w-50 border-0"
          >
            Extend Subscription
          </button>
          {isLoginPage ? (
            <button
              onClick={closeDialog}
              className="cancel-btn d-flex btn btn-link text-decoration-none w-50"
            >
              Cancel
            </button>
          ) : (
            <button
              onClick={() => {
                onLogout();
                closeDialog();
              }}
              className="logout-btn d-flex btn btn-link text-decoration-none w-50"
            >
              Logout
            </button>
          )}
        </div>
      </dialog>
    </div>
  )}
  </>
  );
};

export default SubscriptionPopup;
